import { useLazyQuery, useQuery } from "@apollo/client";
import { PRICE_RULE } from "../price-rule.queries";
import { PriceRuleQuery, PriceRuleQueryVariables } from "../../../__generated__/PriceRuleQuery";

export const usePriceRule = (id: number) => {
  return useQuery<PriceRuleQuery, PriceRuleQueryVariables>(PRICE_RULE, { variables: { id } });
};

export const useLazyPriceRule = () => {
  return useLazyQuery<PriceRuleQuery, PriceRuleQueryVariables>(PRICE_RULE);
};
